module.exports = __webpack_public_path__ + "static/media/0.9372c5e7.jpg";